export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-50 rounded-full mb-4">
              About
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              What Is Kakobuy Spreadsheet
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-800">Kakobuy Spreadsheet</strong> is an organized product directory that helps users discover products quickly, compare prices, and save time while shopping online. It serves as a comprehensive resource for anyone looking to streamline their shopping experience.
              </p>
              <p>
                Instead of searching manually across dozens of pages and websites, users can browse categorized products, compare different options side by side, and find useful buying information all in one convenient location. The kakobuy spreadsheet brings structure and clarity to the online shopping process.
              </p>
              <p>
                Whether you are a first-time buyer or an experienced shopper, our kakobuy spreadsheet provides the tools and information you need to make confident, informed purchasing decisions. From detailed product comparisons to expert buying guides, everything is organized for maximum convenience.
              </p>
            </div>
            <div className="mt-6">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Explore the full spreadsheet
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Organized%20digital%20tablet%20and%20smartphone%20displaying%20colorful%20product%20catalog%20interfaces%20side%20by%20side%20on%20a%20clean%20white%20desk%2C%20bright%20morning%20sunlight%20streaming%20through%20blinds%20creating%20striped%20shadows%2C%20modern%20tech%20lifestyle%20photography%20with%20coffee%20and%20notebook%20nearby&width=900&height=675&seq=whatis-v2-kakobuy&orientation=landscape)`,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}